export default "__VITE_ASSET__BDMKnSpF__"